import React from 'react';
import { Anchor, Stack } from '@mantine/core';
import flowAlternativesOf from '@/function/auth/flow.alternatives.of';
import type { TypeAuthFlow, TypeFlowChoice } from '@/types/auth/types.auth.flow';

type Props = { flow: TypeAuthFlow; current: Exclude<TypeFlowChoice, null>; passkeySupported: boolean };

const FlowAlternatives: React.FC<Props> = ({ flow, current, passkeySupported }) => {
    if (flow.state.phase !== 'step') return null;
    const alternatives = flowAlternativesOf(flow.state.allowed, current, passkeySupported);
    if (alternatives.length === 0) return null;
    return (
        <Stack gap={4} align="center">
            {alternatives.map((alternative) => (
                <Anchor
                    key={alternative.choice}
                    component="button"
                    type="button"
                    size="sm"
                    disabled={flow.busy}
                    style={{ minHeight: 44 }}
                    onClick={() => flow.choose(alternative.choice)}
                >
                    {alternative.label}
                </Anchor>
            ))}
        </Stack>
    );
};

export default FlowAlternatives;
